//#region import libraries
import React from 'react';
//react-select
import Select from 'react-select';
//custom component
import { IataCodes } from '_utils'
//#endregion

const IataSelector = (props) => {

    const handleChange = (selection) => {
        let assistanceList = []
        for (let index = 0; index < selection.length; index++) {
            assistanceList.push(selection[index].value)
        }
    }

    return (
        <Select
            defaultValue={[]}
            isMulti
            name="assistance"
            options={IataCodes}
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={(selection) => { handleChange(selection) }}
        />
    )

}

export default IataSelector;
